import { Booking } from '../../entities/booking';
import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import * as moment from 'moment-timezone';
import { Api } from '../../providers/api';

@Component({
    selector: 'page-dashboard',
    templateUrl: 'dashboard.html',
})
export class DashboardPage {

    bookings: Booking[] = [];
    lastUpdated: string = '';

    constructor(
        private api: Api,
        private navParams: NavParams,
    ) {
        this.lastUpdated = moment().format('HH:mm');
    }

    ngAfterViewInit() {
        let bookings: Booking[] = this.navParams.get('bookings');
        this.processBookings(bookings);
    }

    get strapline(): string {
        return 'Last updated: ' + this.lastUpdated;
    }

    async refreshPage(refresher) {
        let bookings: Booking[] = await this.api.getMyBookings();
        this.bookings = [];
        this.processBookings(bookings);
        this.lastUpdated = moment().format('HH:mm');
        refresher.complete();
    }

    processBookings(bookings: Booking[]) {
        for (let i in bookings) {

            let booking: Booking = Booking.createFromObject(bookings[i]);
            if (booking === undefined) continue;

            switch (booking.status) {
                case 'Pending':
                case 'Confirmed':
                case 'Standby':
                case 'Shipped':
                    break;
                default:
                    continue;
            }
            let twoDaysAgo = moment().startOf('day').subtract({days: 2});
            let twoDaysAgoUnix = parseInt(twoDaysAgo.format('x'));
            let departureUnix = parseInt(booking.departing_at.format('x'));

            if (departureUnix < twoDaysAgoUnix) continue;
            this.bookings.push(booking);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts